import ProfileDetails from "../features/Profile/ProfileDetails"
import SignIn from "../features/Auth/SignIn"
import ForgotPassword from "../features/ChangePassword/ForgotPassword"
import ResetPassword from "../features/ChangePassword/ResetPassword"
import Users from "../features/Users/Users"
import AdminDashboard from "../features/Dashboard/AdminDashboard"
import Tickets from "../features/Tickets/Tickets";
import Affiliate from "../features/Affiliate/Affiliate";
import ErrorDashboard from "../features/ErrorDashboard/ErrorDashboard"
import AuditLogs from "../features/AuditLogs/AuditLogs";
import Settings from "../features/Settings/Settings"
import { globalContext } from '../Provider/AppProvider';
import { useContext } from "react"
import AffiliateTransactions from "../features/Affiliate/AffiliateTransactions"
import PaymentInfo from "../components/shared-components/payment-info/PaymentInfo"
import { isSubscribeDomain, roles } from "../helper"
import EmailUnsubscribe from "../components/shared-components/email-unsubscribe/EmailUnsubscribe";
import NewTickets from "../features/Tickets/NewTickets"

export type navigationPropertiesTypes ={
    path: string,
    component: React.FC
}
type navigationType ={
    public : navigationPropertiesTypes[],
    private: navigationPropertiesTypes[]
}

export const useNavigation =()=>{
    const {globalState} = useContext<any>(globalContext);

    if (isSubscribeDomain()) {
        const navigation: navigationType = {
            public: [
                {
                path: '/unsubscribe',
                component: EmailUnsubscribe,
                },
            ],
            private: [],
        };
        return { navigation };
    }

    const navigation: navigationType = {
        public : [
            {
                path: '/login',
                component: SignIn
            },
            {
                path: '/forgot-password',
                component : ForgotPassword
            },
            {
                path: '/reset-password',
                component: ResetPassword
            },
            {
                path: '/paymentinfo',
                component: PaymentInfo
            }
        ],
        private: globalState.profile.userRole===roles.ADMIN  ? [
            {
                path: '/dashboard',
                component: AdminDashboard
            },
            {
                path:'/tickets',
                component: Tickets
            },
            {
                path:'/users',
                component: Users
            },
            {
                path:'/profile',
                component: ProfileDetails
            },
            {
                path : '/affiliate',
                component : Affiliate
            },
            {
                path : '/affiliate/transactions/:id',
                component : AffiliateTransactions
            },
            {
                path : '/settings',
                component : Settings
            },
            {
                path : '/logs',
                component : ErrorDashboard
            },
            {
                path:'/auditLogs',
                component: AuditLogs
            }
        ]:  globalState.profile.userRole===roles.AFFILIATER_ADMIN ?    [ {
                path: '/dashboard',
                component: AdminDashboard
            },
            {
                path:'/tickets',
                component: Tickets
            },
            {
                path:'/users',
                component: Users
            },
            {
                path:'/profile',
                component: ProfileDetails
            },
            {
                path : '/affiliate',
                component : Affiliate
            },
            {
                path : '/affiliate/transactions/:id',
                component : AffiliateTransactions
            },
            {
                path : '/settings',
                component : Settings
            },
            {
                path : '/logs',
                component : ErrorDashboard
            }
        ] : globalState.profile.userRole === "marketing_user" ? [
            {
                path:'/profile',
                component: ProfileDetails
            },
            {
                path:'/users',
                component: Users
            },
            {
                path : '/affiliate',
                component : Affiliate
            },
            {
                path : '/affiliate/transactions/:id',
                component : AffiliateTransactions
            },
        ]: globalState.profile.userRole === roles.SUPER_USER ?[
            {
                path: '/dashboard',
                component: AdminDashboard
            },
            {
                path:'/new-list',
                component: NewTickets
            },
            {
                path:'/profile',
                component: ProfileDetails
            },
        ]:[
        {
            path:'/tickets',
            component: Tickets
        },
        {
            path:'/profile',
            component: ProfileDetails
        },
        {
            path : '/settings',
            component : Settings
        },
        {
            path : '/logs',
            component : ErrorDashboard
        },]
    } 
    return {navigation}
}
